import SalPlan from "./SalPlan";
export default SalPlan;
